const maltertechUrlParams = new URLSearchParams(window.location.search);

/***************** Estimate Shipping *****************/

// returns estimated shipping range
function getEstimatedShippingRange() {
    const monthToAbbreviation = {
        "January": "Jan",
        "February": "Feb",
        "March": "Mar",
        "April": "Apr",
        "May": "May",
        "June": "Jun",
        "July": "Jul",
        "August": "Aug",
        "September": "Sept",
        "October": "Oct",
        "November": "Nov",
        "December": "Dec"
    };

    // Generate dynamic arrival date: Estimated arrival May 27th - May 31st
    const currentDate = new Date();
    const leadTime = 3;
    const shippingTime = 4;

    // calculate start and end date
    const startDate = new Date(currentDate);
    startDate.setDate(currentDate.getDate() + leadTime);
    const endDate = new Date(currentDate);
    endDate.setDate(currentDate.getDate() + leadTime + shippingTime);

    // format dates
    const startMonth = monthToAbbreviation[startDate.toLocaleString('default', {month: 'long'})];
    const startDay = startDate.getDate();

    // return range
    return `Estimated arrival ${startMonth} ${startDay}`;
}

/**************
 Global
 ***************/

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// get index of a specific element
function getElIndex(el) {
    let i;
    for (i = 0; el = el.previousElementSibling; i++) ;
    return i;
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
async function addProduct(formData, addGifts = false) {
    // pixels
    try {
        _learnq.push(['track', 'Added to Cart', item]);
        fbq('track', 'AddToCart');
    } catch (e) {
        // skip
    }

    // check for free gifts
    if (addGifts) {
        // create a unique id for this group
        const uniqueID = `${new Date().getTime()}`;

        // add gifts to formData
        formData = {
            items: [...gifts, formData]
        };

        // add group id to each item
        formData.items.forEach(item => {
            item.properties = item.properties || {};
            item.properties.__group = uniqueID;
        });
    }

    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    return fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            console.log("UPDATE", data);
            return data.json();
        })
}

//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            return false;
        });
}


// print price ($51.27 = 5127)
function price(amount) {
    let total = (parseFloat(amount) / 100).toFixed(2);
    return `$${total.replace(".00", "")}`;
}

// https://stackoverflow.com/a/46181
function validateEmail(email) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

/********** Checkout / Free Gift **********/

async function goToCheckout() {
    // redirect to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
}